import { Participant } from "./participants.utility.decl";

import { CallDetailsFragment } from "@/graphql/generated/graphql";
import { formatInternational } from "@/helpers/phone_number/phone_number.helpers";
import { capitalizeString } from "@/helpers/string/string.helpers";

/**
 * The function responsible for mapping the backend data of agent/contact(from/to) to a participant type.
 * @param data
 */
export const mapToParticipant = (
  data: CallDetailsFragment["from"] | CallDetailsFragment["to"] | null
): Participant | undefined => {
  if (!data) {
    return;
  }

  const { number } = data;

  if (data.__typename === "AgentParticipant") {
    if (data.teammate.entity.__typename !== "PhoneTeammate") {
      return;
    }

    const { fullName, ID } = data.teammate.entity;
    const trimmedFullName = fullName.trim();

    const displayName = trimmedFullName
      ? capitalizeString(trimmedFullName)
      : formatInternational(number);

    return {
      fullName: trimmedFullName,
      number,
      displayName,
      agentId: ID,
    };
  }

  if (data.__typename === "ExternalParticipant") {
    if (data.external.entity.__typename === "ExternalNumber") {
      return {
        number: data.external.entity.phoneNumber,
        displayName: formatInternational(data.external.entity.phoneNumber),
      };
    }

    if (data.external.entity.__typename === "PhoneContact") {
      const { fullName, companyName } = data.external.entity;
      const trimmedFullName = fullName.trim();

      const displayName = trimmedFullName
        ? capitalizeString(trimmedFullName)
        : formatInternational(number);

      return {
        // In case it's an external number we need to check if he is in our contacts.
        number,
        // fullName is used to display an avatar, if undefined, we don't render the avatar
        fullName: trimmedFullName,
        // displayName is used to display a label next to avatar
        displayName,
        companyName: companyName ?? undefined,
      };
    }
  }
};
